import { Grid, GridCol, SimpleGrid } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import VideoCard, { VideoCardSkeleton } from "../VideoCard/VideoCard"
import { Stat, VideoEvent } from "../../client"
import { resolveTargetPlayerId } from "../../utils/player"

interface VideoDisplayProps {
  action: "add" | "delete" | "view"
  videos: VideoEvent[],
  onSelect: (video: VideoEvent) => void,
  targetPlayerId?: string | null,
  targetPlayerName?: string | null,
  targetPlayerIds?: string[],
  stats?: Stat[],
  isExpanded?: boolean,
  isLoadingMore?: boolean,
}

const VideoDisplay: React.FC<VideoDisplayProps> = ({
  action,
  videos,
  onSelect,
  targetPlayerId,
  targetPlayerName,
  targetPlayerIds,
  stats,
  isExpanded = false,
  isLoadingMore = false,
}) => {
  const isLg = useMediaQuery('(min-width: 1200px)')
  const isMd = useMediaQuery('(min-width: 992px)')

  const cols = isLg
    ? (isExpanded ? 4 : 3)
    : isMd
    ? (isExpanded ? 3 : 2)
    : 1

  const remainder = videos.length % cols
  const toFillCurrentRow = remainder === 0 ? 0 : cols - remainder
  const skeletonCount = toFillCurrentRow + cols

  return (
    <Grid h="100%" overflow="hidden">
      <SimpleGrid h={"100%"} w={"100%"} ml={20} mr={20} m={10} spacing={0} cols={{ base: 1, sm: 1, md: isExpanded ? 3 : 2, lg: isExpanded ? 4 : 3 }}>
          { videos.map((video) => {
            const videoKey = `${video.gameId}-${video.eventNumber}`;
            const resolvedTargetId = (targetPlayerIds && targetPlayerIds.length > 0)
              ? resolveTargetPlayerId(video, targetPlayerIds, stats) || targetPlayerId
              : targetPlayerId;
            return (
              <GridCol key={videoKey} p={0}>
                <VideoCard
                  key={videoKey}
                  action={action}
                  video={video}
                  onSelect={onSelect}
                  targetPlayerId={resolvedTargetId}
                  targetPlayerName={targetPlayerName}
                />
              </GridCol>
            );
          })}
          { isLoadingMore && Array.from(Array(skeletonCount).keys()).map((_item, idx) => (
            <GridCol key={`skeleton-${idx}`} p={0}>
              <VideoCardSkeleton />
            </GridCol>
          ))}
      </SimpleGrid>
    </Grid>
  )
}

export default VideoDisplay